import { render, staticRenderFns } from "./DropdownsupportNav.vue?vue&type=template&id=45599ac6"
import script from "./DropdownsupportNav.vue?vue&type=script&lang=js"
export * from "./DropdownsupportNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports